/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./lib/locales (ignored)
// module id = 2195
// module chunks = 0